/**
 * Takes an address and returns it shortened. eg: 0xfFcA09511931F09De2198Bb0345Dd5e0D941b6C1 => 0xfFcA…b6C1
 */
export const shortenWalletAddress = (address: string): string =>
  `${address.substr(0, 6)}…${address.substr(
    address.length - 4,
    address.length
  )}`;
